module.exports = __webpack_public_path__ + "img/tracy-adams-YSkuPlvE4nc-unsplash.0284ad29.jpg";